import {PureToggleableLeafRule} from "../../slate/html/Html";
import {DeserializedLeafRule} from "../../slate/Transformation";
import Button from "../../../Button";
import React from "react";

export const Rules: {[key: string]: DeserializedLeafRule<HTMLElement>} = {
    "strike": PureToggleableLeafRule({
        leaf: 's',
        toolbarButton: (props) => {
            return <Button
                disabled={props.disabled}
                icon="strike"
                color={props.isActive ? "primary" : "default"}
                tooltip="Áthúzott"
                onClick={(e) => {
                    e && e.preventDefault();
                    props.toggle();
                }}
            />
        }
    })
}